import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MissionControlPageComponent } from './mission-control-page.component';
import { RoleEntityScopePageModule } from './role-entity-scope-page/role-entity-scope-page.module';
import { FormsModule } from '@angular/forms';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { ChangePasswordPageModule } from './change-password-page/change-password-page.module';
import { DashboardPageModule } from './dashboard-page/dashboard-page.module';
import { ManageSkillsPageModule } from './manage-skills-page/manage-skills-page.module';
import { EmployeeManagementPageModule } from './employee-management-page/employee-management-page.module';
import { EmployeesPageModule } from './employees-page/employees-page.module';
import { BulkResumeUploadModule } from 'src/app/shared/bulk-resume-upload/bulk-resume-upload.module';
import { BulkUploadPageModule } from './bulk-upload-page/bulk-upload-page.module';
import { AssessmentsManagementModule } from './assessments-management/assessments-management.module';
import { ClientOrBusPageModule } from './client-or-bus-page/client-or-bus-page.module';
import { NotificationsPageModule } from './notifications-page/notifications-page.module';
import { NotificationPreferencePageModule } from './notification-preference-page/notification-preference-page.module';
import { ManageRequisitionEntitiesPageModule } from './manage-requisition-entities-page/manage-requisition-entities-page.module';
import { ManageMasterListsPageModule } from './manage-master-lists-page/manage-master-lists-page.module';
import { CandidateJobComparisonPageModule } from './candidate-job-comparison-page/candidate-job-comparison-page.module';
import { JobProfilePageModule } from './job-profile-page/job-profile-page.module';
import { FeedbackFormsPageModule } from './feedback-forms-page/feedback-forms-page.module';
import { VendorsPageModule } from './vendors-page/vendors-page.module';
import { CandidatesPageModule } from './candidates-page/candidates-page.module';
import { RequisitionsPageModule } from './requisitions-page/requisitions-page.module';
import { CandidateOutreachPageModule } from './candidate-outreach-page/candidate-outreach-page.module';
import { AiActivitiesPageModule } from './ai-activities-page/ai-activities-page.module';
import { TeamMembersPageModule } from './team-members-page/team-members-page.module';
import { EditSharedReqPageModule } from './edit-shared-req-page/edit-shared-req-page.module';
import { SettingsPageModule } from './settings-page/settings-page.module';
import { SubordinatesInBuModule } from './usermanagement-page/subordinates-in-bu/subordinates-in-bu.module';
import { AddEditUserActionsModalModule } from './usermanagement-page/add-edit-user-actions-modal/add-edit-user-actions-modal.module';
import { AddEditUserPageModule } from './usermanagement-page/add-edit-user-page/add-edit-user-page.module';
import { CompareAndUpdateCandidateDetailsModule } from './add-candidates-page/compare-and-update-candidate-details/compare-and-update-candidate-details.module';
import { UploadResumesActionsModalModule } from './add-candidates-page/upload-resumes/upload-resumes-actions-modal/upload-resumes-actions-modal.module';
import { UploadResumesTransactionCandidatesModalModule } from './add-candidates-page/upload-resumes/upload-resumes-transaction-candidates-modal/upload-resumes-transaction-candidates-modal.module';
import { UploadResumesProcessedCandidatesModule } from './add-candidates-page/upload-resumes/upload-resumes-processed-candidates/upload-resumes-processed-candidates.module';
import { UploadSingleResumeModule } from './add-candidates-page/upload-single-resume/upload-single-resume.module';
import { UploadResumesModule } from './add-candidates-page/upload-resumes/upload-resumes.module';
import { AddCandidatesModule } from './add-candidates-page/add-candidates/add-candidates.module';
import { JobMatchCompareModalModule } from './add-candidates-page/job-match-compare-modal/job-match-compare-modal.module';
import { JobMatchActionsModalModule } from 'src/app/core/services/job-match-actions-modal/job-match-actions-modal.module';
import { AddCandidatesPageModule } from './add-candidates-page/add-candidates-page.module';
import { CandidateProfilePageModule } from './candidateprofile-page/candidateprofile-page.module';
import { CandidateJobMatchCardModule } from './candidate-job-matches-workflow-page/candidate-job-match-card/candidate-job-match-card.module';
import { AddCandidatesFromJobBoardsModule } from './candidate-job-matches-workflow-page/add-candidates-from-job-boards/add-candidates-from-job-boards.module';
import { AssociateCandidatesModule } from './candidate-job-matches-workflow-page/associate-candidates/associate-candidates.module';
import { JobCandidatesCompareModule } from './candidate-job-matches-workflow-page/job-candidates-compare/job-candidates-compare.module';
import { CandidateJobMatchesWorkflowActionsModalModule } from './candidate-job-matches-workflow-page/candidate-job-matches-workflow-actions-modal/candidate-job-matches-workflow-actions-modal.module';
import { CandidateJobMatchesWorkflowModule } from './candidate-job-matches-workflow-page/candidate-job-matches-workflow/candidate-job-matches-workflow.module';
import { CandidateJobMatchesWorkflowPageModule } from './candidate-job-matches-workflow-page/candidate-job-matches-workflow-page.module';
import { UploadReqStepUploadModule } from './upload-req-page/upload-req-step-upload/upload-req-step-upload.module';
import { CompanyPageModule } from './company-page/company-page.module';
import { UploadReqStepRecruitersModule } from './upload-req-page/upload-req-step-recruiters/upload-req-step-recruiters.module';
import { UploadReqStepWorkflowModule } from './upload-req-page/upload-req-step-workflow/upload-req-step-workflow.module';
import { UploadReqStepJobBoardsModule } from './upload-req-page/upload-req-step-job-boards/upload-req-step-job-boards.module';
import { UploadReqStepActivateModule } from './upload-req-page/upload-req-step-activate/upload-req-step-activate.module';
import { UploadReqStepResultsModule } from './upload-req-page/upload-req-step-results/upload-req-step-results.module';
import { UploadReqPageModule } from './upload-req-page/upload-req-page.module';
import { ReviewReportsPageModule } from './review-reports-page/review-reports-page.module';

const states: Ng2StateDeclaration[] = [
  {
    name: 'missioncontrol',
    url: '/missioncontrol',
    component: MissionControlPageComponent,
    data: {
      requireLogin: true,
      companyObject: null,
      companyDeletedShowPopup: null
    }
  }
];

@NgModule({
  declarations: [MissionControlPageComponent],
  imports: [
    CommonModule,
    FormsModule,
    UIRouterModule.forChild({ states }),
    RoleEntityScopePageModule,
    ChangePasswordPageModule,
    DashboardPageModule,
    ManageSkillsPageModule,
    EmployeeManagementPageModule,
    EmployeesPageModule,
    BulkUploadPageModule,
    BulkResumeUploadModule,
    AssessmentsManagementModule,
    ClientOrBusPageModule,
    NotificationsPageModule,
    NotificationPreferencePageModule,
    ManageRequisitionEntitiesPageModule,
    ManageMasterListsPageModule,
    CandidateJobComparisonPageModule,
    JobProfilePageModule,
    FeedbackFormsPageModule,
    VendorsPageModule,
    CandidatesPageModule,
    RequisitionsPageModule,
    CandidateOutreachPageModule,
    AiActivitiesPageModule,
    TeamMembersPageModule,
    EditSharedReqPageModule,
    SettingsPageModule,
    SubordinatesInBuModule,
    AddEditUserActionsModalModule,
    AddEditUserPageModule,
    CompareAndUpdateCandidateDetailsModule,
    UploadResumesActionsModalModule,
    UploadResumesTransactionCandidatesModalModule,
    UploadResumesProcessedCandidatesModule,
    UploadSingleResumeModule,
    UploadResumesModule,
    AddCandidatesModule,
    JobMatchCompareModalModule,
    JobMatchActionsModalModule,
    AddCandidatesPageModule,
    CandidateProfilePageModule,
    CandidateJobMatchCardModule,
    AddCandidatesFromJobBoardsModule,
    AssociateCandidatesModule,
    JobCandidatesCompareModule,
    CandidateJobMatchesWorkflowActionsModalModule,
    CandidateJobMatchesWorkflowModule,
    CandidateJobMatchesWorkflowPageModule,
    UploadReqStepUploadModule,
    UploadReqStepRecruitersModule,
    UploadReqStepWorkflowModule,
    UploadReqStepJobBoardsModule,
    UploadReqStepActivateModule,
    UploadReqStepResultsModule,
    UploadReqPageModule,
    CompanyPageModule,
    ReviewReportsPageModule
  ],
  entryComponents: [MissionControlPageComponent]
})
export class MissionControlPageModule { }
